import { Avatar, Box, Button, IconButton, Tooltip, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";

import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const topBorder = {
    borderTop: 1,
    mt: 0.5,
    pt: 0.5,
    borderColor: "lightgrey"
};

export default function BackButton({ desktop, textButton, enableBorder }) {
    const navigate = useNavigate();
    const desktopVisible = useMediaQuery('(min-width:900px)');

    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    const BackClick = () => {
        navigate(-1);
    };

    return (
        <>
            {desktop ? (
                textButton ? (
                    desktopVisible && (
                        <Button variant="outlined" color="secondary" onClick={BackClick}>
                            {resourceFinal[appLanguage].words.BACK}
                        </Button>
                    )
                ) : (
                    desktopVisible && (
                        <Box sx={{ ...(enableBorder ? topBorder : {}) }}>
                            <Tooltip title={resourceFinal[appLanguage].words.BACK} placement="left" arrow>
                                <IconButton sx={{ alignSelf: 'flex-end' }} onClick={BackClick}>
                                    <Avatar sx={{ bgcolor: 'secondary.main', p: 0.5 }}>
                                        <ArrowBackIcon sx={{ color: 'white.main', fontSize: 48 }} />
                                    </Avatar>
                                </IconButton>
                            </Tooltip>
                        </Box>
                    )
                )
            ) : (
                <IconButton onClick={BackClick} color="secondary">
                    <ArrowBackIcon sx={{ color: 'white.main', fontSize: 32 }} />
                </IconButton>
            )}
        </>
    );
}